import { PostStatus } from '../../../constants';

const restrictedStatuses = [PostStatus.DRAFT, PostStatus.DECLINED, PostStatus.MODERATION];

export const isPostStatusValidForSave = (status: PostStatus) =>
    !restrictedStatuses.includes(status);
